import { withPrefix } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import Article from '../templates/Article'

const EME6208BookCoverPage = props => (
  <Article pathName={props.location.pathname} pageTitle="Book Cover">
    <section
      aria-labelledby="section-book-cover"
      css={css`
        padding-bottom: 5rem;
      `}
    >
      <h1 id="section-book-cover">Book Cover</h1>
      <div className="contain">
        <p>
          For my book cover I chose to redesign my favorite novel, the Pulitzer
          Prize winning{' '}
          <a
            href="https://www.goodreads.com/book/show/256008.Lonesome_Dove?from_search=true&from_srp=true&qid=nUDYQ72vAd&rank=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Lonesome Dove
          </a>{' '}
          by Larry McMurtry. This is the third book in the <i>Lonesome Dove</i>{' '}
          tetralogy, and is an epic adventure and love story from the days of
          cowboys and indians. It follows two Texas Rangers and a group of
          cowboys as they travel from Texas to Montana.
        </p>
        <p>
          I wanted to keep the concept simple. I used a sketch style drawing of
          two cowboys on horse back moving along a path towards a sunset as the
          primary visual.
        </p>
        <img
          src={withPrefix('/media/GettyImages-1195187065.jpg')}
          alt="cowboys on horses sketch"
        />
        <p>
          A gradient overlay provides the appearance of the sun setting to the
          entire cover, letting the early evening sky and the dust of the trail
          provide the overall color scheme. I changed the gradient's layer style
          to <i>multiply</i> which allowed the primary image background color
          and my gradient's colors to blend together for a harmonious scheme.
        </p>
        <div
          css={css`
            text-align: center;
          `}
        >
          <img
            css={css`
              max-width: 300px;
            `}
            src={withPrefix('/media/book-cover-partial-001.jpg')}
            alt="cover with gradient overlay"
          />
        </div>
        <p>
          Next, I added a sprinkle of stars and adjusted the layer style and
          opacity to give the appearance that the stars are more visible at high
          points in the sky and less visible closer to the setting sun.
        </p>
        <div
          css={css`
            text-align: center;
          `}
        >
          <img
            css={css`
              max-width: 450px;
            `}
            src={withPrefix('/media/GettyImages-1157965436.jpg')}
            alt="stars pattern"
          />
        </div>
        <p>
          I used a classic, serif typeface for the title and author information,
          with a slight touch of the dusty brown layered on top of the title
          which helps to tone down the white text the slightest bit. Here is the
          final image.
        </p>
        <div>
          <img
            src={withPrefix('/media/eme6208-book-cover.jpg')}
            alt="Lonesome Dove book cover"
          />
        </div>
      </div>
    </section>
  </Article>
)

EME6208BookCoverPage.propTypes = {
  location: PropTypes.object,
}

export default EME6208BookCoverPage
